import { SET_INPUT_FICHA_MEDICA, BACK_STEEP_FICHA_MEDICA, NEXT_STEEP_FICHA_MEDICA } from "../types";
import IFichaMedicaCarga from "../../interfaces/IFichaMedicaCarga";

export const setDatos = (payload: IFichaMedicaCarga) => ({type: SET_INPUT_FICHA_MEDICA, payload});
export const nextSteep = () => ({type: NEXT_STEEP_FICHA_MEDICA});
export const backSteep = () => ({type: BACK_STEEP_FICHA_MEDICA});